import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import BodyConstants from "segments/desktop/constants";
const BODY_HORIZONTAL_PADDING = `${BodyConstants.BODY_CONTENT_HORIZONTAL_PADDING}px`;
export const StyledTimelineTitledTabTabsComponent = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  margin: auto;

  .full-paragraph-wrapper {
    margin-bottom: 48px;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  .vertical-tabs {
    width: 100%;
    gap: 20px;
    justify-content: space-between;

    .desktop-wrapper {
      width: 100%;

      .vertical-tabs-desktop-component {
        padding: 0 ${BODY_HORIZONTAL_PADDING};

        .vertical-tabs-wrapper {
          .vertical-tabs {
            .content {
              padding-top: 0;
              justify-content: center;
              flex: 1;

              .asset-and-text {
                display: flex;
                flex-direction: column;
                align-items: center;
                align-items: stretch;
                justify-content: space-between;

                .asset-inner {
                  flex-grow: 1;
                  overflow: hidden;

                  img {
                    max-height: 100%;
                    height: 100%;
                    max-width: 100%;
                    width: 100%;
                    object-fit: contain;
                  }
                }

                .title-wrapper {
                  justify-content: center;
                  flex-shrink: 0;
                  overflow: auto;
                  display: flex;
                  align-items: end;
                  width: 100%;

                  .asset-title {
                    text-align: center;
                    line-height: 24px;
                    height: fit-content;
                    align-items: center;
                    font-size: 1rem;
                  }
                }
              }
            }

            .tabs {
              width: fit-content;
              padding-top: 0;

              .tabs-wrapper {
                .vertical-tab {
                  font-size: 1rem;
                  max-width: var(--tab-max-width);
                  line-height: var(--tab-line-height);
                  height: var(--tab-height);

                  &.tab-title {
                    cursor: auto;
                  }

                  &.nested-tab {
                    gap: 40px;

                    &.active {
                      gap: 36px;

                      .tab-label {
                        font-weight: 700;
                      }
                    }
                  }

                  &.active {
                    .vertical-tab-timeline {
                      border-left: 3px solid;
                    }
                  }

                  .vertical-tab-timeline {
                    height: 100%;
                    margin-right: 10px;
                    border: 1px solid;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
